import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

export interface RecommendationSubmission {
    songLink: string;
    instagram?: string;
    comment: string;
}

export const recommendMusic = async (data: RecommendationSubmission) => {
    const db = getFirestore();

    try {
        const docRef = await addDoc(collection(db, "recommendedMusic"), {
            ...data,
            dateSent: serverTimestamp()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding recommendation: ", error);
        throw error;
    }
};